export default __webpack_public_path__ + "static/media/Earnven_menu_text.d427886c.svg";